import { render, staticRenderFns } from "./TxBlockOverlay.vue?vue&type=template&id=7f6b73db&scoped=true&"
import script from "./TxBlockOverlay.vue?vue&type=script&lang=js&"
export * from "./TxBlockOverlay.vue?vue&type=script&lang=js&"
import style0 from "./TxBlockOverlay.vue?vue&type=style&index=0&id=7f6b73db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6b73db",
  null
  
)

export default component.exports